"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    discoveryServiceUrlUat: 'https://discovery-uat.easygenerator.com',
    discoveryServiceUrlStaging: 'https://discovery-staging.easygenerator.com',
    discoveryServiceUrlProduction: 'https://discovery.easygenerator.com'
};
